import axios from "../../utils/axios";
import { buildQueryStringList } from "../../utils/stringUtils";
import type { ActionPresetDTO } from "../types/lookupDtos";

const apiUrl = process.env.REACT_APP_HS_API_URL;

const fetchForSubject = (subjectId, accountId, siteExternalIds) => {
    const sitesList = buildQueryStringList("siteExternalIds", siteExternalIds);

    return axios.get<ActionPresetDTO[]>(`${apiUrl}/ActionPreset/GetBySubjectId/${subjectId}${sitesList ? sitesList : "?"
        }&accountId=${accountId}`);
}


const fetchForIncidents = (accountId, siteExternalIds) => {
    const sitesList = buildQueryStringList("siteExternalIds", siteExternalIds);
    return axios.get<ActionPresetDTO[]>(`${apiUrl}/ActionPreset/GetForIncidents/${sitesList ? sitesList : "?"
        }&accountId=${accountId}`);
}

const addNew = (actionPreset) =>
  axios.post<ActionPresetDTO>(`${apiUrl}/ActionPreset/Add`, actionPreset);

const actionPresetService = {
  fetchForSubject,
  addNew,
  fetchForIncidents,
};

export default actionPresetService;
